import { render, staticRenderFns } from "./detilCost.vue?vue&type=template&id=1994657c&scoped=true"
import script from "./detilCost.vue?vue&type=script&lang=js"
export * from "./detilCost.vue?vue&type=script&lang=js"
import style0 from "./detilCost.vue?vue&type=style&index=0&id=1994657c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1994657c",
  null
  
)

export default component.exports